import React from 'react'
import PropTypes from 'prop-types'
import ButtonArrow from '../../GeneralComponents/ButtonArrow'
import classes from './index.module.css'
import PublicationBadge from '../../GeneralComponents/PublicationBadge'
import ExplicitTag from '../../GeneralComponents/ExplicitTag'

export default function ArtistTopSongGridItem({ song, onClick }) {
  return (
    <div className={classes.itemWrapper} onClick={() => onClick(song)}>
      <div className={classes.imageWrapper}>
        <img
          src={song?.image?.url}
          alt="sound image"
          className={classes.image}
        />
      </div>
      <div className={classes.textWrapper}>
        <div className={classes.songNameWrapper}>
          <p
            className={`${classes.itemTitle} ${
              song?.is_explicit ? classes.shortenTitle : ''
            }`}
          >
            {song?.name}
          </p>
          {song?.is_explicit && <ExplicitTag size="small" />}
        </div>
        <p className={classes.itemSubtitle}>{song?.artist?.name}</p>
        <p className={classes.itemMessageCount}>{`${
          song?.feels_count
        } Feels`}</p>
        {song?.is_promotional ? (
          <PublicationBadge
            size="sm"
            status={song.is_published ? 'published' : 'unpublished'}
            text={song.is_published ? 'Published' : 'Unpublished'}
          />
        ) : null}
      </div>
    </div>
  )
}

ArtistTopSongGridItem.propTypes = {
  song: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
}
